import { api } from '../../api';
import { Storyboard } from '../../app/entities/storyboard';
import { entityPool } from '../../core/engine/engine';
import { Project } from '../../app/entities/project';
import { Shot } from '../../app/entities/shot';
import { Step } from '../../app/entities/step';
import { View } from '../../app/entities/view';

export const fetchStoryboards = async (projectId: string) => {
  const { data } = await api.get(`/projects/${projectId}/storyboards`);
  data.forEach((storyboardItem: Storyboard) => {
    const storyboard = Object.assign(new Storyboard(), storyboardItem);
    entityPool.insert(storyboard);
  });
  return data;
};

export const createStoryboard = async (project: Project) => {
  const { data } = await api.post(`/projects/${project._id}/storyboards`);
  const storyboard = Object.assign(new Storyboard(), data.storyboard);
  const step = Object.assign(new Step(), data.step);

  /**
   * The create response carries the shot-list view the API just built for this storyboard.
   * Without it in the pool `storyboard.resource` stays undefined and the board renders with no
   * properties until the next full reload (PRO-1051). Insert it first so the engine wires the
   * relation as the storyboard goes in, rather than through its dangling-entity path.
   */
  if (data.view) {
    entityPool.insert(Object.assign(new View(), data.view));
  }

  entityPool.insert(storyboard);
  entityPool.insert(step);

  Shot.createShot({
    projectId: project._id,
    position: 1,
  });

  return data;
};
